import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-soft py-3' : 'py-4 md:py-5'}`} data-id="element-127">
      <div className="container mx-auto px-6 md:px-8 flex items-center justify-between" data-id="element-128">
        <a href="#" className="z-50 relative" data-id="element-129">
          <Logo variant="dark" data-id="element-130" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-131">
          <ul className="flex items-center gap-6" data-id="element-132">
            {navLinks.map(link => <li key={link.name} data-id="element-133">
                <a href={link.href} className="text-sm font-medium text-brand-text hover:text-brand-teal transition-colors" data-id="element-134">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contact" className="bg-brand-teal text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-brand-teal/90 transition-colors min-h-[48px] flex items-center justify-center" data-id="element-135">
            Get a Free Quote
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 relative p-2 -mr-2 text-brand-text" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-136">
          {mobileMenuOpen ? <X size={24} data-id="element-137" /> : <Menu size={24} data-id="element-138" />}
        </button>

        {/* Mobile Nav Overlay */}
        <div className={`fixed inset-0 bg-white z-40 flex flex-col pt-24 px-6 pb-8 transition-transform duration-300 ease-in-out md:hidden ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-139">
          <ul className="flex flex-col gap-6 mb-8" data-id="element-140">
            {navLinks.map(link => <li key={link.name} data-id="element-141">
                <a href={link.href} className="text-2xl font-heading font-semibold text-brand-text block py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-142">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <div className="mt-auto" data-id="element-143">
            <a href="#contact" className="bg-brand-teal text-white w-full py-4 rounded-full text-base font-semibold hover:bg-brand-teal/90 transition-colors min-h-[48px] flex items-center justify-center" onClick={() => setMobileMenuOpen(false)} data-id="element-144">
              Get a Free Quote
            </a>
          </div>
        </div>
      </div>
    </header>;
}